import { logger as LOG } from '@garnish/logger';

import { checkIfHasActiveSession, checkIfShouldHandleRedirectResponse } from '../../guards';
import {
  type AzureAuthMachineGuard,
  type CreateAccountOutput,
  type SignInOutput,
} from '../azure-auth-machine.types';

// ─── External Guards ─────────────────────────────────────────────────────────

const checkIfNeedToRefreshTokens: AzureAuthMachineGuard = () => {
  logger.debug('`checkIfNeedToRefreshTokens` guard is not provided.');

  return true;
};

// ─── Internal Guards ─────────────────────────────────────────────────────────

const checkIfSignedIn: AzureAuthMachineGuard<SignInOutput> = (_args, params) => {
  return params.hasSignedIn;
};

const checkIfSignedUp: AzureAuthMachineGuard<CreateAccountOutput> = (_args, params) => {
  return params.hasCreatedAccount;
};

const checkIfSignedOut: AzureAuthMachineGuard = () => {
  return !checkIfHasActiveSession();
};

const checkIfNeedToHandleRedirect: AzureAuthMachineGuard = () => {
  return checkIfShouldHandleRedirectResponse();
};

// ─────────────────────────────────────────────────────────────────────────────

export const Guards = {
  checkIfNeedToRefreshTokens,
  checkIfSignedIn,
  checkIfSignedUp,
  checkIfSignedOut,
  checkIfNeedToHandleRedirect,
};

// ─── Logger ──────────────────────────────────────────────────────────────────

const logger = LOG.extend('AZURE AUTH STATE MACHINE');
